import _curry1 from "./internal/_curry1.js";
var fromPairs = _curry1(function fromPairs(pairs) {
    var result = {};
    var idx = 0;
    while (idx < pairs.length) {
        result[pairs[idx][0]] = pairs[idx][1];
        idx += 1;
    }
    return result;
});
export default fromPairs;
